<template>
  <div  >
    <modal :id="'portlet-calculo'" :modal="'modal-lg'">      
      <template slot="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="cerrarModal()"></button>
          <h4 class="modal-title">Configurar Cálculo</h4>
      </template>
      <template slot="modal-body" @keypress="keypr($event)" tabindex="0">           
        <div class="row" id="form_calculo">
          <div class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="form-group col-md-12">
                  <label>Datos del calculo</label>
                  <select2 class="form-control" :options="options" v-model="campo_tramite" :disabled="disabled_campo_config==true" @eventchange="changeCampo()">
                      <option :value="0" class="text-gray" :selected="0">--Seleccione el Campo--</option>
                      <option v-for="b in data_campos" :value="b.id" v-if="b.tipo_nombre=='numeric'"> {{ b.campo_nombre }}</option>
                  </select2>
                </div>
                <div class="form-group col-md-10">
                  <div class="portlet light bordered">
                    <div class="portlet-body row" style="height: 80px;overflow-y:auto;">
                      <div class="col-md-1">
                        <span class="help-block">fx</span>
                      </div>
                      <div class="col-md-11">
                        <span v-for="(f,i) in formula">
                          <span v-if="f.calculo">(</span> 
                          <span v-if="f.calculo" v-for="(c,i_c) in f.calculo" > &nbsp; 
                            <span v-if="c.campo" class="label-bordered" title="Editar"href="#portlet-calculo-editar" data-toggle='modal' v-on:click="editar_formula(i,i_c,c.campo,'campo')">{{ c.campo }} </span>
                            <span v-else-if="c.valor" class="label-bordered" title="Editar" href="#portlet-calculo-editar" data-toggle='modal' v-on:click="editar_formula(i,i_c,c.valor,'numero')">{{ c.valor }} </span>
                            <span v-else-if="c.operador" class="label-bordered" title="Editar"href="#portlet-calculo-editar"  data-toggle='modal' v-on:click="editar_formula(i,i_c,c.operador,'operador')">{{ c.operador }} </span>
                          </span>
                          <span v-if="i==formula.length-1 && f.calculo && !valida_formula"></span>
                          <span v-else-if="f.calculo"> )</span>
                          <span v-if="f.operador" class="label-bordered" title="Editar" href="#portlet-calculo-editar" data-toggle='modal'  v-on:click="editar_formula(i,null,f.operador,'operador')">{{ typeof(f.operador)!=='undefined' ? f.operador: f.operador}} </span> &nbsp; 
                          </span>
                          <span class="cursor"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group text-right">
                    <button type="button" class="btn btn-sm btn-danger" title="Borrar ultimo" v-on:click="clearLast(true)"><i class="fa fa-eraser"></i> Ultimo</button>&nbsp;
                  </div>
                  <span class="help-block">&nbsp;</span>
                  <div class="form-group text-right">
                    <button type="button" class="btn btn-sm btn-danger" title="Borrar todo" v-on:click="clearFormula()"><i class="fa fa-eraser"></i> Todo</button>&nbsp;
                  </div>
                </div>
                <div class="col-md-12 well form-group">
                  <div class="col-md-7">
                    <div class="form-group border-left-text text-blob">&nbsp;Campos</div>
                    <div class="form-group">
                      <select2 class="form-control" :options="options" v-model="campo_calculo" :disabled="disabled_input_s==true" @eventchange="change_select()">
                        <option :value="0" class="text-gray">--Seleccione el Campo--</option>
                        <option v-for="b in data_campos_select" :value="b.id"> {{ b.campo_nombre }}</option>
                      </select2>
                    </div>
                    <div class="form-group">
                      <div class="col-md-4 form-group" title="Valor de la UMA diaria vigente">
                        <button type="button" class="btn btn-default" v-on:click="btn_uma_click('UMA – D')" :disabled="disabled_input_s==true" >UMA – D </button>
                      </div>
                      <div class="col-md-4 form-group" title="Valor de la UMA mensual vigente">
                        <button type="button" class="btn btn-default" v-on:click="btn_uma_click('UMA – M')" :disabled="disabled_input_s==true">UMA – M </button>
                      </div>
                      <div class="col-md-4 form-group" title="Valor de la UMA anual vigente">
                        <button type="button" class="btn btn-default" v-on:click="btn_uma_click('UMA – A')" :disabled="disabled_input_s==true">UMA – A </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group border-left-text text-blob">&nbsp;Funciones</div>
                    <div class="col-md-4 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="btn_parentisis_click('(')" :disabled="disabled_btn_i==true"> ( </button></div>
                    <div class="col-md-4 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="btn_parentisis_click(')')" :disabled="disabled_btn_f==true"> ) </button></div>
                    <div class="col-md-4 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="btn_operador('+')" :disabled="disabled_btn==true"> + </button></div>
                    <div class="col-md-4 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="btn_operador('-')" :disabled="disabled_btn==true"> - </button></div>
                    <div class="col-md-4 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="btn_operador('x')" :disabled="disabled_btn==true"> x </button></div>
                    <div class="col-md-4 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="btn_operador('÷')" :disabled="disabled_btn==true"> ÷ </button></div>
                  </div>
                </div>
                <div class="col-md-12 form-group">
                  <div class="md-checkbox">
                    <input type="checkbox" id="redondear" name="redondear" class="md-check" v-on:change="changeRedondeo()">
                    <label for="redondear"><span></span><span class="check"></span> <span class="box"></span> ¿Resultado redondeado?</label>
                    <span class="help-block">Opcional</span>
                  </div>
                </div>
                <div class="col-md-12 form-group" :hidden="!hidden_redondeo">
                 <div class="md-radio-list" v-for="b in data_redondeo" >
                    <div class="md-radio">
                      <input type="radio" name="check_redondear" :id="`radio${b.id}`" class="md-radiobtn" :value="b.id" >
                      <label :for="`radio${b.id}`" ><span></span><span class="check"></span><span class="box"></span> {{ b.nombre }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 form-group">
                  <button type="button" class="btn blue" v-on:click="validaForm()"><i class="fa fa-check"></i> Guardar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <button type="button"  class="btn default" v-on:click="cerrarModal()">Cerrar</button>
      </template>
    </modal>
    <modal :id="'portlet-calculo-editar'" :modal="'modal-md'">      
      <template slot="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="cerrarModalEditar()"></button>
          <h4 class="modal-title">Editar {{ texto_calculo }}</h4>
      </template>
      <template slot="modal-body">           
        <div class="row">
          <div class="col-md-12 form-group" :hidden="!hidden_campos">
            <div class="form-group border-left-text text-blob">&nbsp;Campos</div>
            <div class="form-group">
              <select2 class="form-control" :options="options" v-model="e_campo_calculo" @eventchange="add_calculo(null,'select')">
                <option :value="0" class="text-gray">--Seleccione el Campo--</option>
                <option v-for="b in data_campos_select" :value="b.id"> {{ b.campo_nombre }}</option>
              </select2>
            </div>
            <div class="form-group">
              <input type="text" v-model="e_campo_numero" class="form-control valida-decimal" placeholder="Valor de operacion" v-on:change="add_calculo('null','numero')">
            </div>
            <div class="form-group">
              <div class="col-md-4" title="Valor de la UMA diaria vigente">
                <button type="button" class="btn btn-default" v-on:click="add_calculo('UMA – D','uma')">UMA – D </button>
              </div>
              <div class="col-md-4" title="Valor de la UMA mensual vigente">
                <button type="button" class="btn btn-default" v-on:click="add_calculo('UMA – M','uma')">UMA – M </button>
              </div>
              <div class="col-md-4" title="Valor de la UMA anual vigente">
                <button type="button" class="btn btn-default" v-on:click="add_calculo('UMA – A','uma')">UMA – A </button>
              </div>
            </div>
          </div>
          <div class="col-md-12 form-group" :hidden="!hidden_operador">
            <div class="form-group border-left-text text-blob">&nbsp;Funciones</div>
            <div class="col-md-3 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="add_calculo('+','operador')" > + </button></div>
            <div class="col-md-3 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="add_calculo('-','operador')" > - </button></div>
            <div class="col-md-3 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="add_calculo('x','operador')"> x </button></div>
            <div class="col-md-3 form-group text-center"><button type="button" class="btn btn-default btn-lg" v-on:click="add_calculo('÷','operador')"> ÷ </button></div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
       <div class="text-left"> <button type="button" class="btn btn-danger float-left" data-dismiss="modal" v-on:click="deleteCampo()"><i class="fa fa-trash"></i> Eliminar </button></div>
        <button type="button" class="btn default" data-dismiss="modal" v-on:click="cerrarModalEditar()">Cerrar</button>
      </template>
    </modal>
  </div>
</template>
<script>

  import axios from 'axios'
  import select2 from '../General/Select.vue'
  import modal from '../General/Modal.vue'
  export default {
    data(){
      return{
        data_redondeo:[],
        data_campos_select:[],
        campo_tramite:0,
        campo_calculo:'',
        campo_numero:'',
        id_reg:0,
        formula:[],
        formula_texto:'',
        options:[],
        valida_formula:false,
        valida_parentisis:false,
        hidden_redondeo:false,
        disabled_btn:true,
        disabled_btn_i:false,
        disabled_btn_f:true,
        disabled_input_s:true,
        disabled_input_n:true,
        disabled_campo_config:false,
        texto_calculo:'',
        hidden_campos:false,
        hidden_operador:false,
        nodo_principal:null,
        nodo_secundario:null,
        e_campo_calculo:'',
        e_campo_numero:'',
      }
    },
    components: {select2,modal},
    name:"Calculo",
    props: {data_campos:[],data_registro:[],tramite_id:0,orden:0},
    mounted () {
      this.findRedondeo();
      window.addEventListener("keypress", this.keypr);
    },
    beforeDestroy() {
      window.removeEventListener("keypress",  this.keypr);
    },     
    methods:{
      loadTable(){
        this.$emit('loadTable');
      },
      btn_parentisis_click(tipo){
        if(this.validaCampoCalculo()){return;}
        if(tipo=="("){
          this.valida_parentisis=true;
          this.valida_formula=false;
          this.check_disabled(false,false,true,true,true);
          this.add_item('inicio',{'calculo':[]});
        }else if(tipo==")"){
          this.valida_parentisis=false;
          this.valida_formula=true;
          this.check_disabled(true,true,false,true,true);
          this.formulaText(this.formula);
        }
        this.campo_numero='';
      },
      changeCampo(){
        this.data_campos_select=this.data_campos.filter(function(item) {
          return item.id != this.campo_tramite;
        }, this);
        setTimeout(() => { this.campo_calculo=0; }, 400);
      },
      change_select(){
        if(this.campo_calculo !== "0"){
          if(this.validaCampoCalculo()){return;}
          let dta= this.data_campos.find(item => item.id == this.campo_calculo);
          if(dta.id==this.campo_tramite){
            this.notifications('400','Elige un campo diferente al seleccionado');
            return;
          }
          this.valida_formula=false;
          this.add_item('select',{'relationship': this.campo_calculo,'campo': dta.campo_nombre});
        }else{
          return;
        }
        this.check_disabled(true,true,false,true,false);
        this.campo_calculo=0;
        this.campo_numero='';
      },
      btn_uma_click(uma){
        this.add_item('select',{ 'uma': true, 'campo': uma, 'valor': null});
        this.check_disabled(true,true,false,true,false);
        this.campo_calculo=0;
        this.campo_numero='';
      },
      campoNumeros(){
        if(this.validaCampoCalculo()){return;}
        if(this.campo_numero !=''){ 
          this.valida_formula=false;
          this.add_item('input',{'valor': this.campo_numero});
        }else{
          return;
        }
        this.check_disabled(true,false,false,true,false);
        this.campo_calculo=0;
      },
      btn_operador(tipo){
        if(this.validaCampoCalculo()){return;}
        if(!this.valida_parentisis && this.formula_texto.length > 0){
          this.check_disabled(true,true,true,false,true);
        }else{
          this.check_disabled(false,false,true,true,true);
        }
        this.add_item('btn',{'operador': tipo});
        this.valida_formula=false;
        this.campo_numero='';
      },
      editar_formula(nodo_p,nodo_s,valor,tipo){
        this.nodo_principal=nodo_p;
        this.nodo_secundario=nodo_s;
        this.texto_calculo=tipo+' '+ valor;        
        if(tipo=='operador'){
          this.hidden_operador=true;
          this.hidden_campos=false;
        }else{
          this.hidden_operador=false; 
          this.hidden_campos=true;
        }
        if(tipo=='numero'){
          this.e_campo_numero=valor;
        }
      },
      add_calculo(valor,tipo){
        let objs={};
        if(tipo=='operador'){
          objs={'operador': valor};
        }else if(tipo=='select'){
          if(this.e_campo_calculo==0){return;}
          let dta= this.data_campos.find(item => item.id == this.e_campo_calculo);
          if(dta){
            objs={'id_relationship': dta.id,'campo': dta.campo_nombre}
          }
        }else if(tipo=='uma'){
           objs={ 'uma': true, 'campo': valor, 'valor': null};
        }else if(tipo=='numero'){
          objs={'valor': this.decimales(this.e_campo_numero)};
          this.campo_numero= this.campo_numero.length>0 ? this.decimales(this.e_campo_numero) : '';
        }else{
           return;
        }
        this.deleteItems();
        if(this.nodo_principal!=null && this.nodo_secundario!=null){
          Object.assign(this.formula[this.nodo_principal].calculo[this.nodo_secundario], objs);
        }else{
          Object.assign(this.formula[this.nodo_principal], objs)
        }
        if(tipo!='numero'){this.cerrarModalEditar();}
        this.formulaText(this.formula);
      },
      deleteItems(){
        if(this.nodo_principal!=null && this.nodo_secundario!=null){
          Object.keys(this.formula[this.nodo_principal].calculo[this.nodo_secundario]).forEach(k => this.$delete(this.formula[this.nodo_principal].calculo[this.nodo_secundario], k)); 
        }else{
          Object.keys(this.formula[this.nodo_principal]).forEach(k => this.$delete(this.formula[this.nodo_principal], k));
        }
      },
      deleteCampo(){
        this.hidden_campos=false;
        if(this.nodo_principal!=null && this.nodo_secundario!=null){
          if(this.formula.length== this.nodo_principal+1 && this.formula[this.formula.length-1].calculo.length==this.nodo_secundario+1){
            if(this.valida_parentisis){ this.clearLast();return;}
          }
        }else{
           if(this.formula.length== this.nodo_principal+1){
            if(!this.valida_parentisis){ this.clearLast();return;}
          }
        }
        if(this.nodo_principal!=null && this.nodo_secundario!=null){
          if(this.formula[this.nodo_principal].calculo.length==1){
            this.formula.splice(this.nodo_principal,1);
            this.valida_parentisis=false;
            if(this.formula.length==0){
              this.check_disabled(true,true,true,false,true);
            }else if(typeof(this.formula[this.formula.length-1].operador) !=='undefined'){
              this.check_disabled(true,true,true,false,true);
              this.valida_formula=false;
            }else if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined' && !this.valida_parentisis){
              this.check_disabled(true,true,false,true,true);
              this.valida_formula=true;
            }else{
              this.formula[this.nodo_principal].calculo.splice(this.nodo_secundario,1);
            }
          }else{
            this.formula[this.nodo_principal].calculo.splice(this.nodo_secundario,1);
          }
        }else{
          this.formula.splice(this.nodo_principal,1);
        }
        this.formulaText(this.formula);
      },
      validaFormula(){
        let valido=true;
        if(this.formula.length==0){ return false; }
        this.formula.forEach((item,index)=>{
          let tipo=(index/2) % 1 !== 0;
          if(!tipo){
            if(item.operador){ valido= false; }
          }
          if(tipo){
            if(!item.operador){ valido= false; }
          }
          if(this.formula.length===index+1){
            if(item.operador){ valido= false; }
          }
          if(item.calculo){
            item.calculo.forEach((c,i_c)=>{
              let tipo_c=(i_c/2) % 1 !== 0;
              if(!tipo_c){
                if(c.operador){ valido= false; }
              }
              if(tipo_c){
                if(!c.operador){ valido= false; }
              }
              if(item.calculo.length===i_c+1){
                if(c.operador){ valido= false; }
              }
            })
          }
        })
        return valido;
      },
      add_item(tipo,object_item){
        if(tipo=='inicio'){
          this.formula.push(object_item);
        }else if(tipo=='select'){
          if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined'){
           this.formula[this.formula.length-1].calculo.push(object_item);
          }
        }else if(tipo=='input'){
          if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined' &&this.formula[this.formula.length-1].calculo.length==0){
            this.formula[this.formula.length-1].calculo.push(object_item);
          }else if(typeof(this.formula[this.formula.length-1].calculo[this.formula[this.formula.length-1].calculo.length-1].valor) !=='undefined'){
            this.formula[this.formula.length-1].calculo[this.formula[this.formula.length-1].calculo.length-1].valor=object_item.valor;
          }else{this.formula[this.formula.length-1].calculo.push(object_item);}
        }else if(tipo=='btn'){
          if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined' && !this.valida_formula){
            this.formula[this.formula.length-1].calculo.push(object_item);
          }else{
            this.formula.push(object_item);
          }
        }
        this.formulaText(this.formula);
      },
      clearLast(){
        if(this.formula.length==0){
          this.valida_parentisis=false;
          this.valida_formula=false;
          this.check_disabled(true,true,true,false,true);
          return;
        }
        if(this.valida_formula){
          this.valida_parentisis=true;
          this.valida_formula=false;
          this.check_disabled(true,true,false,true,false);
        }else if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined' && this.formula[this.formula.length-1].calculo.length>0){
          this.formula[this.formula.length-1].calculo.pop();
          this.valida_formula=false;
          this.valida_parentisis=true;
          if(this.formula[this.formula.length-1].calculo.length==0){
            this.check_disabled(false,false,true,true,true);
          }else if(typeof(this.formula[this.formula.length-1].calculo[this.formula[this.formula.length-1].calculo.length-1].operador)!=='undefined'){
            this.check_disabled(false,false,true,true,true);
          }else{
            this.check_disabled(true,true,false,true,false);
          }
        }else if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined' && this.formula[this.formula.length-1].calculo.length==0){
            this.formula.pop();
            this.valida_parentisis=false;
            if(typeof(this.formula[this.formula.length-1].operador) !=='undefined'){
              this.check_disabled(true,true,true,false,true);
              this.valida_formula=false;
            }else{
              this.check_disabled(true,true,false,true,true);
              this.valida_formula=true;
            }
        }else{
          if(typeof(this.formula[this.formula.length-1].operador) !=='undefined'){
            this.formula.pop();
            this.valida_parentisis=false;
            if(typeof(this.formula[this.formula.length-1].operador) !=='undefined'){
              this.check_disabled(true,true,true,false,true);
              this.valida_formula=false;
            }else{
              this.check_disabled(true,true,false,true,true);
              this.valida_formula=true;
            }
          }else{
            this.formula.pop();
            this.valida_parentisis=false;
            this.valida_formula=false;
            if(this.formula.length==0){
              this.check_disabled(true,true,true,false,true);
            }else if(typeof(this.formula[this.formula.length-1].calculo) !=='undefined' && this.formula[this.formula.length-1].calculo.length>0){
              this.valida_parentisis=false;
              this.check_disabled(true,true,false,true,false);
            }else{
              this.check_disabled(true,true,true,false,true);
            }
          }
        }
        this.campo_numero='';
        this.formulaText(this.formula);
      },
      validaCampoCalculo(){
         if(this.campo_tramite==0){
          this.notifications('400','Elige un Campo a aplicar');
          return true;
        }
        this.disabled_campo_config=true;
        return false;
      },
      check_disabled(select,input,btn_operadores,btn_inicio,btn_fin){
        this.disabled_input_s=select;
        this.disabled_input_n=input;
        this.disabled_btn=btn_operadores;
        this.disabled_btn_i=btn_inicio;
        this.disabled_btn_f=btn_fin;
      },
      changeSelectCalculo(){
        if(this.campo_calculo!=0){this.campo_numero='';}
      },
      changeInputCalculo(){
        if(this.campo_numero!=''){this.campo_calculo=0;}
      },
      changeRedondeo(){
        let check=$("#redondear").prop("checked");
        $("input:radio").attr("checked", false);
        if(check){
          this.hidden_redondeo=true;
        }else{
          this.hidden_redondeo=false;
        }
      },
      validaForm(){
        let check=$("#redondear").prop("checked");
        let option= document.querySelector('input[name = check_redondear]:checked');
        if(option!=null) {
          option = document.querySelector('input[name = check_redondear]:checked').value;
        }
        if(!this.valida_formula){
          this.notifications('400','Calculo incompleto, verifique cerrar parentisis');
        }else if(!this.validaFormula()){
          this.notifications('400','Calculo incorrecto, verifique la formula');
        }else if(this.tramite_id==0){
          this.notifications('400','Selecciona el tramite, requerido!');
        }else if(this.campo_tramite==0){
          this.notifications('400','Selecciona el campo, requerido!');
        }else if(check && option==null){
          this.notifications("400","Selecciona el tipo de redondeo, Requerido!");
        }else{
          let dta= this.data_campos.find(item => item.id == this.campo_tramite);
          let data={
            'id':this.id_reg,
            'id_tramite': this.tramite_id,
            'id_relationship': this.campo_tramite,
            'id_campo': dta.campo_id,
            'redondeo': option== null ? 0 : option,
            'formula_texto': this.formula_texto,
            'formula': this.formula,
            'orden':this.orden + 1,
            'status':1
          };
          this.saveCalculo(data);
        }
      },
      saveCalculo(data){
        axios.post(`${process.env.APP_URL}/calculo-tramite`,data)
        .then((response)=>{
          this.notifications(response.data.status,response.data.message);
          if(response.data.status==200){
            this.clearForm();
            if(this.id_reg!==0){ this.cerrarModal(); }
          }
        }).catch(error=>{ 
          console.log('Tipos:' + error); 
          this.notifications(error.response.data.status,error.response.data.message);
        });
      },
      findRedondeo(){
        axios.get(`${process.env.APP_URL}/calculo-redondeo`).then((response)=>{
            this.data_redondeo=response.data.response;
        }).catch(error=>{ console.log('Tipos:' + error); });
      },
      decimales(valor){
        valor = valor.replace(/[^0-9.]/g,'');
        if (valor.indexOf('.') !== -1) {
            let parts = valor.split('.');
            parts[1] = parts[1].substring(0, 4);
            valor = parts[0] + '.' + parts[1];
        }
        return valor;
      },
      cerrarModalEditar(){
        this.e_campo_calculo=0;
        this.e_campo_numero='';
        this.hidden_campos=false;
        this.hidden_operador=false;
        //this.nodo_principal=null;
        //this.nodo_secundario=null;
        $("#portlet-calculo-editar").modal('hide');
      },
      cerrarModal(){
        this.id_reg=0;
        $("#portlet-calculo").modal('hide');
        this.clearForm();
        this.loadTable();
      },
      clearForm(){
        this.campo_tramite = 0; 
        this.disabled_campo_config=false;
        this.campo_calculo = 0;
        this.campo_numero='';
        this.formula=[];
        this.formula_texto='';
        $("#redondear").prop("checked", false);
        $("input:radio").attr("checked", false);
        this.check_disabled(true,true,true,false,true);
        this.hidden_redondeo=false;
        this.valida_parentisis=false;
      },
      clearFormula(){
        this.formula=[];
        this.campo_numero='';
        this.formula_texto='';
        this.check_disabled(true,true,true,false,true);
        if(this.id_reg==0){
          this.disabled_campo_config=false;
          this.campo_tramite = 0; 
        }
      },
      notifications(Code,Message){
        if(Code=="200"){  Command: toastr.success(Message, "Notifications");  }
        else{  Command: toastr.warning(Message, "Notifications"); }
      },
      keypr(event){
        if(event.key==="(" && !this.disabled_btn_i){
          event.preventDefault();
          this.btn_parentisis_click('(');
        }else if(event.key===")" && !this.disabled_btn_f){
          event.preventDefault();
          this.btn_parentisis_click(')');
        }else if(event.key==="+" && !this.disabled_btn){
          event.preventDefault();
          this.btn_operador(event.key);
        }else if(event.key==="/" && !this.disabled_btn){
          event.preventDefault();
          this.btn_operador("÷");
        }else if(event.key==="*" && !this.disabled_btn){
          event.preventDefault();
          this.btn_operador("x");
        }else if(event.key==="-" && !this.disabled_btn){
          event.preventDefault();
          this.btn_operador(event.key);
        }else if(this.decimales(event.key) && !this.disabled_input_n && !this.hidden_campos){
          event.preventDefault();
          this.campo_numero+=event.key;
          this.campo_numero=this.decimales(this.campo_numero);
          this.campoNumeros();
        }
      },
      formulaText(formulax){
        this.formula_texto='';
        formulax.forEach((f,index) => {
          if(f.calculo){
            this.formula_texto+=' (';
            f.calculo.forEach((c) => {
              if(c.valor){ this.formula_texto+= ' ' + c.valor; }
              if(c.campo){ this.formula_texto+= ' ' + c.campo; }
              if(c.operador){ this.formula_texto+= ' ' + c.operador; }
            });
          }
          if(index==formulax.length-1 && f.calculo && !this.valida_formula){ }
          else if(f.calculo){ this.formula_texto+=' )';  }
          if(f.operador){ this.formula_texto+= ' ' + f.operador;  }
        });
      }
    },
    watch:{
      data_registro(reg){
        this.disabled_campo_config=typeof(reg.id)=='undefined' ? false : true;
        this.id_reg = typeof(reg.id)=='undefined' ? 0 : reg.id;
        this.campo_tramite = typeof(reg.id_relationship)=='undefined' ? 0 : reg.id_relationship;
        this.formula= typeof(reg.formula)=='undefined' ? [] : reg.formula;
        this.formula_texto= typeof(reg.formula_texto)=='undefined' ? '' : reg.formula_texto;
        if(reg.id==0){
          this.check_disabled(true,true,true,false,true);
          this.valida_formula=false;
        }else{
          this.check_disabled(true,true,false,true,true);
          this.valida_formula=true;
        }
        let red=typeof(reg.id_redondeo)=='undefined' ? 0 : reg.id_redondeo;
        if(red!=0){
          $("#redondear").prop("checked", true);
          this.hidden_redondeo=true; 
          $('input[name=check_redondear][value='+reg.id_redondeo+']').attr('checked', true);
        }
      }
    },
    computed: {
    }       
  }
</script>
<style scoped>
  .border-left-text{
    border-left: 5px solid #ff8400;
  }
  .text-blob{
      font-weight: bold !important;
  }
  textarea {
    resize: none;
  }
  .text-gray{
    color:#888 !important;
  }
  .form-control[disabled]{
    cursor: not-allowed;
    background-color: #ffffff;
  }
  .label-bordered{
    text-shadow: none !important;
    font-size: 14px;
    font-weight: 300;
    padding: 1px 1px 1px 1px !important;
    color: #000;
    font-family: inherit;
    background-color: #ffffff;
    border-bottom: 1px #d3d3d3 solid;
    cursor: pointer;
  }
  .cursor {
    display: inline-block;
    width: 1px;
    height: 16px;
    background-color: black;
    margin-left: 2px;
    animation: blink 1.1s infinite;
    vertical-align: bottom;
  }
  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }
  #portlet-calculo-editar{
    margin-top: 100px;
  }
</style>